angular.module('app.controllers').controller('HomeCtrl', ['$scope', '$rootScope', 'UI', 'APIRead', '$location'].append(function(self, root, UI, APIRead, $location) {
  APIRead.query({
    entry_type: 'campaign',
    limit: 100,
    full: true,
    lang: root.lang || 'es'
  }, function(data) {
    return self.campaigns = data.filter(function(c) {
      var ref;
      return (ref = c.exhibitor_id) === 1269650 || ref === 1269987;
    });
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  self.videos = [
    {
      "embed": "https://www.youtube.com/embed/PkUZyemHtKk",
      "thumbs": {
        "default": "https://img.youtube.com/vi_webp/PkUZyemHtKk/hqdefault.webp",
        "maxres": "https://img.youtube.com/vi_webp/PkUZyemHtKk/maxresdefault.webp"
      }
    }
  ];
  self.video = document.getElementById('video');
  self.source_mp4 = document.getElementById('source_mp4');
  self.source_ogv = document.getElementById('source_ogv');
  self.source_webm = document.getElementById('source_webm');
  self.video.addEventListener("ended", function(event) {
    self.video.classList.add('watched');
    return self.$applyAsync();
  });
  self.video.addEventListener("pause", function(event) {
    if (!(self.video.currentTime > 0)) {
      self.video.classList.add('watched');
    }
    return self.$applyAsync();
  });
  self.video.addEventListener("playing", function(event) {
    self.customStat(null, 'main_video', 'Opened main video');
    return self.$applyAsync();
  });
  self.video.addEventListener("click", function(event) {
    return self.$applyAsync();
  });
  self.resetVideo = function() {
    return self.video.currentTime = 0;
  };
  self.skipVideo = function() {
    self.video.pause();
    self.video.currentTime = 0;
    return self.video.classList.add('watched');
  };
  self.toggleVolume = function() {
    if (self.video.muted || self.video.volume === 0.0) {
      self.video.muted = false;
      return self.video.volume = 0.5;
    }
    if (self.video.volume === 0.5) {
      return self.video.volume = 1.0;
    }
    if (self.video.volume === 1.0) {
      return self.video.volume = 0.0;
    }
  };
  self.$on('pauseVideo', function(event) {
    if (!self.video.paused && !self.video.ended) {
      self.video.pause();
    }
  });
  self.$on('playVideo', function(event) {
    if (self.video.paused && !self.video.ended) {
      self.video.play();
    }
  });
  self.$on('resetLangVideo', function(event) {
    var save_ended_status, save_paused_status, save_time_status, video_played;
    video_played = !self.video.paused && !self.video.ended && self.video.currentTime !== 0;
    if (video_played) {
      self.video.pause();
    }
    save_ended_status = angular.copy(self.video.ended);
    save_paused_status = angular.copy(self.video.paused);
    save_time_status = angular.copy(self.video.currentTime);
    self.source_mp4.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.mp4');
    self.source_ogv.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.ogv');
    self.source_webm.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.webm');
    if (save_paused_status && !save_ended_status && save_time_status !== 0) {
      self.video.load();
      self.video.play();
    }
  });
  return self.$on('$destroy', function() {
    var ref;
    return (ref = self.video) != null ? ref.pause() : void 0;
  });
}));
